export default __webpack_public_path__ + "static/media/population.1bc7b9b8.svg";